import React,{Component} from 'react';
import Logger from './common/Logger';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Логируем ошибку в файл
        const errorMessage = `ErrorBoundary caught error: ${error?.message || error?.toString() || 'Unknown error'}`;
        const errorStack = error?.stack || 'No stack trace';
        const componentStack = errorInfo?.componentStack || 'No component stack';
        
        Logger.error(`${errorMessage}`);
        Logger.error(`Stack: ${errorStack}`);
        Logger.error(`Component Stack: ${componentStack}`);
        Logger.error(`Error Info: ${JSON.stringify(errorInfo)}`);
        
        // Также выводим в консоль для отладки
        console.error('ErrorBoundary caught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Можно вернуть fallback UI, но пока возвращаем children
            return this.props.children;
        }
        return this.props.children;
    }
}